import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=dd04da74&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd04da74')) {
      api.createRecord('dd04da74', component.options)
    } else {
      api.reload('dd04da74', component.options)
    }
    module.hot.accept("./Viewer.vue?vue&type=template&id=dd04da74&", function () {
      api.rerender('dd04da74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/gobierto_dashboards/webapp/Viewer.vue"
export default component.exports